import React from 'react';
import './styles.css';
import { get } from 'lodash';
import FormattedMessage from 'components/FormattedMessage/index';

const CompanyDetailsSummary = ({
  companyDetails
}) => {
  const companyName = get(companyDetails, "company_name", "")
  const uenNumber = get(companyDetails, "uen", "")
  const businessAddress = get(companyDetails, "company_address", "")
  return (
    <div className="company-info-card">
      {/* Details Grid */}
      <div className="company-info-grid">
        <div className="detail-item">
          <span className="detail-label">Full company name</span>
          <div className="detail-value">{companyName}</div>
        </div>

        <div className="detail-item">
          <span className="detail-label">UEN no.</span>
          <div className="detail-value">{uenNumber}</div>
        </div>

        <div className="detail-item full-width">
          <span className="detail-label">Business address</span>
          <div className="detail-value">{businessAddress}</div>
        </div>
      </div>

      {/* Info Banner */}
      <div className="info-banner">
        <svg
          className="info-icon"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#64748b"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span className="info-text">
          <FormattedMessage html id="ent_acra_upload_declare_info" defaultMessage="" />
        </span>
      </div>
    </div>
  );
};

export default CompanyDetailsSummary;